<template>
  <div class="flex justify-between items-start mb-4">
    <div class="space-y-1">
      <h1 class="text-xl font-medium">{{ pageTitle }}</h1>
      <p class="text-gray-500" v-if="description" v-text="description" />
    </div>
    <slot name="header"></slot>
  </div>
  <slot></slot>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>

<style></style>
